import { fetchApi, fetchJson } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';
import type { DashboardData, DashboardUrlsResponse } from '@/common-types';

/**
 * Get presigned URLs for dashboard data from /api/health/dashboard
 * Response: { message, data: { customers: { dashboard7d, dashboard30d }, all: { dashboard7d, dashboard30d }, generatedAt } }
 */
export async function getDashboardUrls(): Promise<DashboardUrlsResponse> {
  const response = await fetchApi<DashboardUrlsResponse>(API_ENDPOINTS.DASHBOARD);
  return response.data;
}

/**
 * Get dashboard data from presigned S3 URL
 */
export async function getDashboardData(url: string): Promise<DashboardData> {
  return fetchJson<DashboardData>(url);
}

/**
 * Trigger dashboard workflow (admin only)
 */
export async function triggerDashboardWorkflow(): Promise<void> {
  await fetchApi(API_ENDPOINTS.TRIGGER_DASHBOARD, {
    method: 'POST',
  });
}

export default {
  getDashboardUrls,
  getDashboardData,
  triggerDashboardWorkflow,
};
